import { render, staticRenderFns } from "./archiv.vue?vue&type=template&id=7224f98c&scoped=true&"
import script from "./archiv.vue?vue&type=script&lang=js&"
export * from "./archiv.vue?vue&type=script&lang=js&"
import style0 from "./archiv.vue?vue&type=style&index=0&id=7224f98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224f98c",
  null
  
)

export default component.exports